// Retrieves SafetyCulture users okta user id from local storage
import { oktaAuth } from "../okta";

// Needed in payload for checking action permissions
export const getOktaUserId = async () => {
  const userClaims = await oktaAuth.getUser();
  return userClaims.sub || "";
};
